import { isVisible } from "@sitebuilder/utils/dom";

// const isVisible = (id) => document.getElementById(id).offsetParent != null;

const utils = {
  isVisible,
  isMobile: () => isVisible("is-md"),
  isMediaXs: () => isVisible("is-xs"),
  isMediaMd: () => isVisible("is-md"),
  isMediaLg: () => isVisible("is-lg"),
  isMediaXl: () => isVisible("is-xl"),
};

export default utils;
